/* eslint-disable @typescript-eslint/no-unused-vars */
export default ({ app }, inject) => {
    inject('castToNumberStandard', castToNumberStandard)
}

function castToNumberStandard(value) {
    const valueAsLocal = value.toLocaleString('en-US')
    return valueAsLocal
}
